import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { CaseFile } from "../_types/case-file";
import { CaseNoteFile } from "../_types/case-note-file";

@Injectable({
    providedIn: 'root',
})
export class CasesNotesFilesService extends Service<CaseNoteFile> {
    public override type = 'caseNoteFiles';
    public override url = 'attendance/caseNoteFiles';
}
